module.exports = __webpack_public_path__ + "media/JDC_cny_muted.1e7b9eea.mp4";